import * as React from 'react';
import * as moment from 'moment';

import LazyImage from '../../components/lazy-image';

import { ListEventProps } from '../../components/list/event';

const ListEventView: React.StatelessComponent<ListEventProps> = props => {
    const todayMoment = moment();
    const eventMoment = moment(props.event.eventDate);
    const isEventInPast = eventMoment.isBefore(todayMoment, 'day');
    const showModal = (id :string) => {
        const modals = window["allModalRefs"];
        if (modals) {
            const modal = modals[id];
            if (modal) {
                modal.modal.show();
            }
        }

    }
    return (
        <li className="ace-cal-list-event"> 
            <article className="ace-cal-list-event-content">
                <div className="ace-cal-list-event-image">
                    <div className="ace-cal-list-event-image-inner">
                        <LazyImage role="presentation" src={props.event.thumbnail ? props.event.thumbnail : props.text.fallbackPerformanceThumbnailImage} alt="" className="ace-cal-list-event-image-img" />
                    </div>
                </div>
                <div className="ace-cal-list-event-details">
                    <h5 className="ace-cal-list-event-name"><a href={props.event.viewDetailCtaUrl}>{props.event.name}</a></h5>
                    <p className="ace-cal-list-event-time">{eventMoment.format("h:mm A")}</p>
                    {
                        props.event.location.length > 0 ?
                            <p className="ace-cal-list-event-venue">{props.event.location}</p>
                        : ""
                    }
                    {
                        props.event.composer && props.event.composer.length > 0 ?
                            <p className="ace-cal-list-event-composer">By {props.event.composer}</p> 
                            : ""
                    }
                    {
                        props.event.synopsis && props.event.synopsis.length > 0 ?
                            <div className="ace-cal-list-event-synopsis rich-text"><p>{props.event.synopsis}</p></div>
                            : ""
                    }
                    {
                        props.event.optionalMessage && props.event.optionalMessage.length > 0 
                            ? <div className="ace-cal-list-event-synopsis rich-text"><p>{props.event.optionalMessage}</p></div>
                            : ""
                    }
                    {
                        props.event.buyTicketCtaUrl.length > 0 && props.event.priceText ? <p className="ace-cal-list-event-price">{props.event.priceText}</p> : null
                    }
                    {
                        props.event.accessibilityInfo ? props.event.accessibilityInfo.map(a => <button type="button" className="btn-link ace-cal-list-modal-btn" onClick={() => { showModal(a.name) }}><p>{a.title}</p><img className="ace-cal-grid-event-img" src={a.icon} /></button>) : null
                    }
                    {/* If not sold out */}
                    {
                        props.event.buyTicketCtaUrl.length > 0 ? (
                            <p className="ace-cal-list-event-cta"><a href={props.event.buyTicketCtaUrl} className="btn">{props.event.buyTicketCtaText}</a></p>
                            ): ""
                    }
                    {/* If sold out */}
                    {
                        props.event.buyTicketCtaUrl.length === 0 ? (
                            <p className="ace-cal-list-event-na">{props.event.buyTicketCtaText}</p>
                        ) : ""
                    }
                </div>
            </article>
        </li>
    );
}

export default ListEventView;